import { boot } from '@dazn/bootstrap-lib';
/***************
 *
 * /!\ IMPORTANT /!\
 *
 * This file is being compiled and exported separately
 * as `/constants.js`, see `tsconfig.constants.json`
 * It is then being used in targets to configure bootstrap
 * So for backwards compatibility and to help targets to upgrade bootstrap,
 * it is advised to keep this file as simple as possible
 **************/
type ChapterName = boot.config.ChapterName;
/**
 * Object Map of constants from config module for chapter names
 */
const chapterNames = {
    AUTH: 'auth',
    SIGN_IN: 'signin',
    MY_ACCOUNT: 'account',
    LANDING_PAGE: 'landingpage',
    CATALOG: 'catalog',
    PREFERENCES: 'preferences',
    HELP: 'help',
    ERROR: 'error',
    REDEEM: 'redeem',
    PICKS: 'picks',
    NEWS: 'news',
    PARTNERS: 'partners',
    FANZONE: 'fanzone',
    AUTH_SIGNIN: {
        dazn: 'auth_signin_dazn',
        kayo: 'auth_signin_kayo',
        binge: 'auth_signin_binge',
        foxtelgnc: 'auth_signin_foxtelgnc',
        foxsports: 'auth_signin_foxsports',
    },
} as const;

type Environment = boot.config.Environment;
const environments = {
    DEVELOPMENT: 'development',
    TESTING: 'testing',
    EDGE: 'edge',
    STAGING: 'staging',
    PRODUCTION: 'production',
} as const;

const USER_STATES = {
    ANONYMOUS: 'Anonymous',
    FREEMIUM: 'Freemium',
    PREMIUM: 'Premium',
};

const NATIVE_APP_IDENTIFIER = '_nativeApp';
const PARTNER_APP_IDENTIFIER = 'partnerApp';
const TEMP_NATIVE_TOKEN = 'tempToken';
const TEMP_AUTH_TOKEN = 'tempAuthToken';
const LOGOUT_KEYWORD = 'logout';
const validNativeApps = ['ios', 'android', 'tvos', 'androidtv'];

const AUTH_TOKEN = 'AUTH_TOKEN';
const CHECK_AND_REFRESH = 'CHECK_AND_REFRESH';
const USER_SIGNOUT_REALTIME = 'USER_SIGNOUT_REALTIME';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const ANONYMOUS_TOKEN_LSKEY = 'MISL.anonToken';
const AUTH_TOKEN_LSKEY = 'MISL.authToken';
const WEB_VIEW_IN_ACTIVE = 'WebInActiveState';
const WEB_VIEW_ACTIVE = 'WebActiveState';

const REFRESH_TOKEN_ERRORS = {
    errorStatus: {
        UNAUTHORISED: '401',
    },

    errorId: {
        PLAYBACK_UNAUTHORIZED_RAT: '063',
        AUTHENTICATION_TOKEN_EXPIRED: '033',
    },
    errorCategory: {
        REFRESH_TOKEN_SERVICE: '66',
    },
};

const REFRESH_TOKEN_PUBBY_ROOM = 'user:refreshAccessToken';
const SSO_TOKEN_KEY = '_sso';
const TOKEN_EXP_LIMIT = 300; // in seconds
const RTL_LANGUAGES = ['ar', 'he'];
const NATIVE_SESSION = 'nativeSession';
const NATIVE_SESSION_COOKIE_EXPIRY = 5;
const BACK_TO_APP_CALLBACK = 3000;
const onetrustDelayInMs = 2000;
const KNOWN_SESSION = 'known_session';
const LAST_KNOWN_USER_STATUS = 'last_known_user_status';

const isBeta = () => window.location.hostname.includes('beta');

const AWIN_CHANNEL_COOKIE = 'AwinChannelCookie';
const AWIN_COOKIE_EXPIRY_DAYS = 30;
const AFFILIATE_PARAMS = [
    'awc',
    'utm_source',
    'source',
    'gclid',
    'fbclid',
    'channel',
    'comissionGroup',
] as const;

const BRANDS = {
    DAZN: 'dazn',
    BINGE: 'binge',
    KAYO: 'kayo',
    FOXTELGNC: 'foxtelgnc',
    FOXSPORTS: 'foxsports',
};

const VERSIONS = {
    v1: 'v1',
    v2: 'v2',
    v3: 'v3',
    v4: 'v4',
    v5: 'v5',
    v6: 'v6',
};

export {
    ChapterName,
    chapterNames,
    Environment,
    environments,
    AUTH_TOKEN,
    NATIVE_APP_IDENTIFIER,
    validNativeApps,
    REFRESH_TOKEN_ERRORS,
    REFRESH_TOKEN_PUBBY_ROOM,
    SSO_TOKEN_KEY,
    TOKEN_EXP_LIMIT,
    CHECK_AND_REFRESH,
    TEMP_NATIVE_TOKEN,
    TEMP_AUTH_TOKEN,
    USER_SIGNOUT_REALTIME,
    RTL_LANGUAGES,
    NATIVE_SESSION,
    NATIVE_SESSION_COOKIE_EXPIRY,
    BACK_TO_APP_CALLBACK,
    isBeta,
    LOGIN_SUCCESS,
    ANONYMOUS_TOKEN_LSKEY,
    AUTH_TOKEN_LSKEY,
    onetrustDelayInMs,
    LOGOUT_KEYWORD,
    USER_STATES,
    PARTNER_APP_IDENTIFIER,
    BRANDS,
    KNOWN_SESSION,
    VERSIONS,
    LAST_KNOWN_USER_STATUS,
    AWIN_CHANNEL_COOKIE,
    AWIN_COOKIE_EXPIRY_DAYS,
    AFFILIATE_PARAMS,
    WEB_VIEW_IN_ACTIVE,
    WEB_VIEW_ACTIVE,
};
